import { Alert, AppBar, Button, Link, Snackbar, Stack, Toolbar, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { Box } from "@mui/system";
import { getAllEnumValues } from "enum-for";
import { useState } from "react";
import { App, AppSpec, getAppSpec } from "../domain/App";
import AppItem from "./home/AppItem";

const Home = () => {
	const [open, setOpen] = useState(false);

	getAllEnumValues(App)
		.map((it) => {
			return getAppSpec(it);
		})
		.map((appSpec: AppSpec) => {
			const routePath = appSpec.routePath;
			const path = `privacy-policy/${routePath}`;
			console.log(path);
			return appSpec;
		});

	const handleClick = () => {
		setOpen(true);
	};

	const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
		if (reason === "clickaway") {
			return;
		}

		setOpen(false);
	};

	return (
		<Box
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
			}}
		>
			<AppBar position="static" elevation={0}>
				<Toolbar>
					<Typography variant="h6">MG Software</Typography>
				</Toolbar>
			</AppBar>
			<Box style={{ height: 80 }} />
			<Typography variant="h4" style={{ fontWeight: 700 }}>
				TOP Apps
			</Typography>
			<Box style={{ height: 60 }} />
			<Box
				style={{
					width: "550px",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					flexWrap: "wrap",
					gap: 16,
				}}
			>
				{getAllEnumValues(App)
					.map((it) => {
						return getAppSpec(it);
					})
					.map((appSpec) => {
						return <AppItem appSpec={appSpec} />;
					})}
			</Box>
			<Box style={{ height: 80 }} />
			<Typography variant="h6">See more my Apps & Games</Typography>
			<Box
				style={{
					height: 100,
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<Button
					variant="outlined"
					size="large"
					style={{ borderRadius: 32, borderWidth: 2 }}
					href="https://play.google.com/store/apps/developer?id=MG+Software&hl=pl&gl=US"
				>
					More
				</Button>
			</Box>
			<Box
				style={{
					width: "100%",
					height: 200,
					backgroundColor: grey[900],
					display: "flex",
					justifyContent: "end",
					alignItems: "end",
					padding: 32,
					boxSizing: "border-box",
				}}
			>
				<Box style={{}}>
					<Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
						<Alert severity="success" sx={{ width: "100%" }}>
							Email coppied to clipboard.
						</Alert>
					</Snackbar>
					<Typography variant="h5" color="white" style={{ fontWeight: 500 }}>
						Contact
					</Typography>
					<Box style={{ height: 16 }} />
					<Stack direction="row">
						<Typography variant="body2" color="white">
							Email:
						</Typography>
						<pre style={{ height: 0, margin: 0 }}> </pre>
						<Link
							href="#"
							underline="hover"
							variant="body2"
							onClick={() => {
								handleClick();
								navigator.clipboard.writeText("mgsoftware95@gmail.com");
							}}
						>
							mgsoftware95@gmail.com
						</Link>
					</Stack>
				</Box>
			</Box>
		</Box>
	);
};

export default Home;
